import { getCookie, parseNumber } from "../../utils"
import { getSiteCourseList, getTikuUserVipFlag } from "@api"

export default {
  state: {
    siteData: {},
    vipInfo: {
      userVipFlag: false, // 类型：Boolean  必有字段  备注：用户是否为会员
      dateEnd: '', // 类型：String  必有字段  备注：会员截止日期(标准时间格式)
      dateEndStr: '', // 类型：String  必有字段  备注：会员截止日期(格式化截取日期)
      vipProductFlag: false, // 类型：Boolean  必有字段  备注：辅导科目是否有题库会员商品
      vipProductPrice: 0, // 类型：Number  必有字段  备注：会员商品价格
      vipRightsNum: 0 // 类型：Number  必有字段  备注：会员权益数量
    }
  },
  mutations: {
    SET_SITE_INFO: (state, data) => {
      state.siteData = data
    },
    SET_VIP_INFO: (state, data) => {
      state.vipInfo = data
    }
  },
  actions: {
    getAllSiteInfo: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        let { flag, majorID } = data
        majorID = parseNumber(majorID)
        const uid = parseNumber(getCookie("cdeluid"))
        let params = {
          flag: flag,
          majorID: majorID,
          userID: uid
        }
        getSiteCourseList(params).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getCurrentSiteInfo: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        const { flag, majorID, siteCourseID } = data
        const uid = parseNumber(getCookie("cdeluid"))
        let params = {
          flag: flag,
          majorID: majorID,
          userID: uid
        }
        getSiteCourseList(params).then(res => {
          let currentItem = {}
          res.forEach(item => {
            if (item.siteCourseID === siteCourseID) {
              currentItem = item
            }
          })
          let result = { allSiteList: res, currentCourse: currentItem }
          resolve(result)
          commit('SET_SITE_INFO', result)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getTikuUserVipFlag: ({ commit }, data) => {
      const uid = parseNumber(getCookie("cdeluid"))
      const params = {
        courseEduId: data.courseEduID,
        eduSubjectId: data.eduSubjectID,
        uid: uid
      }
      getTikuUserVipFlag(params).then(res => {
        if (res.success && res.result){
          commit('SET_VIP_INFO', res.result)
        }
      })
    }
  }
}
